// extracted by css-extract-rspack-plugin
export default {"input":"src-modules-desktop-modules-files-integration-components-InlineNameInput-InlineNameInput-module__input-ekOCYm","hasError":"src-modules-desktop-modules-files-integration-components-InlineNameInput-InlineNameInput-module__hasError-dt8oTQ"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"input\":\"src-modules-desktop-modules-files-integration-components-InlineNameInput-InlineNameInput-module__input-ekOCYm\",\"hasError\":\"src-modules-desktop-modules-files-integration-components-InlineNameInput-InlineNameInput-module__hasError-dt8oTQ\"}";
        // 1793873552684
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  